<div class="nf-page-header">
	<div class="page-title">
		Alerts
	</div>
</div>


<div class="scroll-content">
	<div class="middle-block">
		<div class="date-blocks" *ngIf="alertsMap.size > 0">
			<div class="date-block" *ngFor="let alertEntry of alertsMap | keyvalue : returnZero">
				<div class="date-title">
					<span class="date-span"
						[class.late-date]="alertEntry.key < today">{{alertEntry.key | date:'MMMM d'}}</span>

				</div>
				<div class="nfs-block">
					<div *ngFor="let alert of alertEntry.value">

						<app-project-alert [projectAlert]="alert"></app-project-alert>

					</div>
				</div>
			</div>
		</div>
		<div class="date-block no-alerts" *ngIf="alertsMap.size === 0">
			<span>No Alerts</span>
		</div>
	</div>
	<!-- <div class="footer-block">
		<p-paginator [rows]="limit" [totalRecords]="totalElements$ | async" (onPageChange)="onPageChange($event)"></p-paginator>

	</div> -->
</div>